import LoginForm from '../components/LoginForm/LoginForm';
import { useAuth } from '../services/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const LoginPage = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if(user) {
      navigate('/');
    }
  }, [user, navigate]);
  
  const handleLogin = async (email, password) => {
    await login(email, password);
  };

  if(user) {
    return null;
  }

  return (
    <div className="login-page">
      <LoginForm onLogin={handleLogin} />
    </div>
  );
};

export default LoginPage;
